import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/SplashScreen.vue')
  },
  {
    path: '/game/coming-soon',
    name: 'GameComingSoon',
    component: () => import('../views/game/ComingSoon.vue')
  },
  {
    path: '/wiki/coming-soon',
    name: 'WikiComingSoon', 
    component: () => import('../views/wiki/ComingSoon.vue')
  },
  // Dynamic wiki routes for scalability
  {
    path: '/wiki/:category',
    name: 'WikiCategory',
    component: () => import('../views/wiki/Category.vue'),
    props: true
  },
  {
    path: '/wiki/:category/:subcategory',
    name: 'WikiSubcategory',
    component: () => import('../views/wiki/Subcategory.vue'),
    props: true
  },
  {
    path: '/wiki/:category/:subcategory/:article',
    name: 'WikiArticle',
    component: () => import('../views/wiki/Article.vue'),
    props: true
  },
  // Catch all 404
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router